module.exports = __webpack_public_path__ + "assets/img/37_1604.9090c544.jpg";